import { defineMessages } from 'react-intl';

const messages = defineMessages({
  name: {
    id: 'App.ManagePaymentBatchesDetails.Name',
    defaultMessage: 'Name',
  },
  status: {
    id: 'App.ManagePaymentBatchesDetails.Status',
    defaultMessage: 'Status',
  },
  type: {
    id: 'App.ManagePaymentBatchesDetails.Type',
    defaultMessage: 'Type',
  },
  date: {
    id: 'App.ManagePaymentBatchesDetails.Date',
    defaultMessage: 'Date',
  },
  period: {
    id: 'App.ManagePaymentBatchesDetails.Period',
    defaultMessage: 'Period',
  },
  amount: {
    id: 'App.ManagePaymentBatchesDetails.Amount',
    defaultMessage: 'Amount',
  },
  doc: {
    id: 'App.ManagePaymentBatchesDetails.Doc',
    defaultMessage: 'Doc #',
  },
  note: {
    id: 'App.ManagePaymentBatchesDetails.Note',
    defaultMessage: 'Note',
  },
  view: {
    id: 'App.ManagePaymentBatchesDetails.View',
    defaultMessage: 'View',
  },
  noDataDescription: {
    id: 'App.ManagePaymentBatchesDetails.NoDataDescription',
    defaultMessage: 'There is currently no data to display',
  },
  subsidy: {
    id: 'App.ManagePaymentBatchesDetails.Subsidy',
    defaultMessage: 'Subsidy',
  },
  resident: {
    id: 'App.ManagePaymentBatchesDetails.Resident',
    defaultMessage: 'Resident',
  },
  notes: {
    id: 'App.ManagePaymentBatchesDetails.Notes',
    defaultMessage: 'NOTES:',
  },
  notes1: {
    id: 'App.ManagePaymentBatchesDetails.Notes1',
    defaultMessage:
      '(1) “Open” payments have not been posted to resident ledgers or deposited.',
  },
  notes2: {
    id: 'App.ManagePaymentBatchesDetails.Notes2',
    defaultMessage:
      '(2) Edits to a batch can only be made while the status is “Open.”',
  },
});

export default messages;
